import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientCommercialApiAdapter, UpdateCommercialRequest } from '../adapters/ClientCommercialApiAdapter';

export const useUpdateCommercial = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientCommercialApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (data: UpdateCommercialRequest) =>
            apiAdapter.updateCommercial(teamId, data),
        onSuccess: () => {
            // Invalidar la cache del cliente para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        updateCommercial: mutation.mutate,
        updateCommercialAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

